import * as React from 'react';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';
import { ConfigurationModel, WashBasinModel } from 'franke-trough-dependencies';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo, faCheck } from '@fortawesome/free-solid-svg-icons';
import { Tooltip, Button } from 'reactstrap';
import { requestAPIActions } from 'loopback-react-request';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './BasinDimensions.messages';

export interface PlateDimensionsRequiredProps {
  configuration: GlobalPrivateState['configuration'];
  dispatch: any;
  id: string;
  requiredWidth: number;
  requiredDistances: number[];
  widthLimitReached: boolean;
}

export interface PlateDimensionsRequiredState {
  tooltipOpen: boolean;
}

export class PlateDimensionsRequiredPartial extends React.Component<PlateDimensionsRequiredProps, PlateDimensionsRequiredState> {
  constructor(props: PlateDimensionsRequiredProps) {
    super(props);

    this.state = {
      tooltipOpen: false
    };
    this.toggle = this.toggle.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  public render() {
    const tollTipId = `plate_dimensions_required_tooltip_${this.props.id}`;

    return <>
      <span className="info-icon" id={tollTipId}>
        <FontAwesomeIcon icon={faInfo} />
        <Tooltip 
        autohide={false}
        isOpen={this.state.tooltipOpen} 
        placement="top"
        toggle={this.toggle}
        target={tollTipId}
        >
          {(this.props.widthLimitReached) ? (
            <p>
              <strong>
              <FormattedMessage {...MESSAGES.dimensionsRequiredHint}/>
              </strong>&nbsp;<FormattedMessage {...MESSAGES.dimensionsRequiredLimitMessage} />
            </p>
          ) : (
            <>
              <p>
                <strong>
                <FormattedMessage {...MESSAGES.dimensionsRequiredHint}/>
                </strong>&nbsp;<FormattedMessage {...MESSAGES.dimensionsRequiredMessage} values={{requiredDimension: this.props.requiredWidth}}/>
              </p>
              <p className="text-right">
                <Button 
                onClick={(ev: React.MouseEvent<HTMLButtonElement>) => this.handleClick(ev, 'submit')}
                className="yes"
                >
                <FontAwesomeIcon icon={faCheck} />
                </Button>
              </p>
            </>
          )}
        </Tooltip>
      </span>
    </>;
  }

  private get configuration(): ConfigurationModel | undefined {
    return this.props.configuration && this.props.configuration.result;
  }

  private dispatchConfiguration() {
    if (!this.configuration) { return; }
    const { washBasinDimension, apronBackSplash } = this.configuration;

    // TODO ... Use default values for PlateDimensionsHeight
    if (!washBasinDimension) { return; }

    // Currently the plateDimensionsRequired popup only shows for Apron... if they confirm it, we automatically add the apron and save the current washbasin stuff (to be restored later)
    if (apronBackSplash && washBasinDimension.distances) {
      apronBackSplash.apron = 'with';
      apronBackSplash.apronHeight = 60;
      apronBackSplash.restorablePlateDimensions = {
        plateWidth: washBasinDimension.plateWidth,
        distances: JSON.parse(JSON.stringify(washBasinDimension.distances))
      }
    }

    const data: WashBasinModel = washBasinDimension;
    data.plateWidth = this.props.requiredWidth;
    data.distances = this.props.requiredDistances;

    this.props.dispatch(requestAPIActions.load(
      'configuration', {
        url: `/Configurations/${this.configuration && this.configuration.id}`,
        options: {
          method: 'PATCH',
          data: {
            washBasinDimension: data,
            apronBackSplash
          }
        },
      },
      true,
    ));
  }

  private handleClick(event: React.MouseEvent<HTMLButtonElement>, type: 'submit' | 'cancel') {
    if (type === 'submit') {
      this.dispatchConfiguration();
    }
  }

  private toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }
}

export const PlateDimensionsRequired = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
}))(PlateDimensionsRequiredPartial);

export default PlateDimensionsRequired;


